<template>
  <BookingsTable :status="status" :range="'thisweek'" />
</template>
<script>
import BookingsTable from "@/components/BookingsTable.vue";
import { ref } from "vue";
export default {
  name: "ApprovedBookings",
  components: {
    BookingsTable,
  },
  setup() {
    const status = ref("approved");
    return {
      status,
    };
  },
};
</script>
